module.exports = __webpack_public_path__ + "static/media/notification-only.2d3f549d.png";